export enum LandingPage {
  Dashboard = 0,
  Calendar = 1,
  Referrals = 2,
}
